export const ONE_HOUR_IN_SECONDS = 60 * 60
export const ONE_DAY_IN_SECONDS = 24 * 60 * 60
export const TWO_DAYS_IN_SECONDS = ONE_DAY_IN_SECONDS * 2
export const HALF_A_YEAR_IN_MILLISECONDS = 1000 * 60 * 60 * 24 * 180
